module.exports = __webpack_public_path__ + "media/images/regions/Tahoua-30574551a96de1fe510d451cda0631d3.png";